import { render, staticRenderFns } from "./CtcArticlesView.vue?vue&type=template&id=a30adc60&scoped=true&"
import script from "./CtcArticlesView.vue?vue&type=script&lang=js&"
export * from "./CtcArticlesView.vue?vue&type=script&lang=js&"
import style0 from "./CtcArticlesView.vue?vue&type=style&index=0&id=a30adc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30adc60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDataTable,VIcon})
